import React, { useState } from "react";
import { StatCard, Expandable, DataTable, SectionTitle, LastSynced, EmptyState } from "./DashboardPrimitives";

const AzureDashboard = ({ data, formatLastConnected }) => {
  const [open, setOpen] = useState({ vms: true, networks: false, storage: false, sql: false, cosmos: false });
  const toggle = (key) => setOpen((p) => ({ ...p, [key]: !p[key] }));

  if (!data?.connector_data) return <EmptyState message="No Azure data available" />;

  const { cspm, dspm } = data.connector_data;
  const subscription = cspm?.subscriptions?.[0];

  return (
    <div className="space-y-6">
      {/* Identity strip */}
      <div className="pb-4 border-b border-gray-100">
        <p className="text-sm font-semibold text-gray-800">{subscription?.displayName}</p>
        <p className="text-xs text-gray-400 mt-0.5">Subscription ID: {subscription?.subscriptionId}</p>
        <p className="text-xs text-gray-400">Tenant ID: {subscription?.tenantId} · State: {subscription?.state}</p>
        <LastSynced value={data?.last_synced_at} formatFn={formatLastConnected} />
      </div>

      {/* Cloud Assets */}
      <div>
        <SectionTitle title="Cloud Assets" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard label="Virtual Machines" value={cspm?.virtual_machines?.length || 0} />
          <StatCard label="Virtual Networks" value={cspm?.networks?.length || 0} />
        </div>
      </div>

      {/* Data Assets */}
      <div>
        <SectionTitle title="Data Assets" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard label="Storage Accounts" value={dspm?.storage_accounts?.length || 0} />
          <StatCard label="SQL Servers" value={dspm?.sql_servers?.length || 0} />
          <StatCard label="Cosmos DB Accounts" value={dspm?.cosmos_dbs?.length || 0} />
        </div>
      </div>

      {/* Details */}
      <div className="space-y-3">
        <Expandable title="Virtual Machines" isOpen={open.vms} onToggle={() => toggle("vms")}>
          <DataTable
            headers={["Name", "Location", "Resource Group", "ID"]}
            rows={(cspm?.virtual_machines || []).map((vm) => [vm.name, vm.location, vm.id.split("/resourceGroups/")[1]?.split("/")[0] || "—", vm.id])}
          />
        </Expandable>
        <Expandable title="Virtual Networks" isOpen={open.networks} onToggle={() => toggle("networks")}>
          <DataTable headers={["Name", "Location", "ID"]} rows={(cspm?.networks || []).map((v) => [v.name, v.location, v.id])} />
        </Expandable>
        <Expandable title="Storage Accounts" isOpen={open.storage} onToggle={() => toggle("storage")}>
          <DataTable headers={["Name", "Location", "ID"]} rows={(dspm?.storage_accounts || []).map((s) => [s.name, s.location, s.id])} />
        </Expandable>
        <Expandable title="SQL Servers" isOpen={open.sql} onToggle={() => toggle("sql")}>
          <DataTable headers={["Name", "Location", "ID"]} rows={(dspm?.sql_servers || []).map((s) => [s.name, s.location, s.id])} />
        </Expandable>
        <Expandable title="Cosmos DB Accounts" isOpen={open.cosmos} onToggle={() => toggle("cosmos")}>
          <DataTable headers={["Name", "Location", "ID"]} rows={(dspm?.cosmos_dbs || []).map((c) => [c.name, c.location, c.id])} />
        </Expandable>
      </div>
    </div>
  );
};

export default AzureDashboard;
